import BanTemplatesPage from "./BanTemplatesPage";


export default function AdminJailTemplatesPage() {
    return (
        <BanTemplatesPage
            apiPath="/settings/adminJailTemplates"
            pageTitle="Admin Jail Templates"
            kindLabel="admin jail"
            allowMinutes
        />
    )
}
